import { Controller } from 'stimulus';

// Per-user color picker for a job status. Persists via PATCH /jobs/status_color.
// Updates the swatch UI immediately; the colored pill rerenders on next page load.
export default class extends Controller {
  static values = { statusName: String, url: String };

  choose(event) {
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget;
    const preset = button.dataset.preset;
    const name = this.element.dataset.statusColorPickerStatusName;
    const url = this.element.dataset.statusColorPickerUrl;
    if (!name || !url) return;

    this.element.querySelectorAll('.jlv-swatch').forEach((b) => b.classList.remove('is-on'));
    button.classList.add('is-on');

    const formData = new FormData();
    formData.append('name', name);
    formData.append('preset', preset);

    fetch(url, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': Rails.csrfToken(), Accept: 'application/json' },
      body: formData,
      credentials: 'same-origin'
    });
  }
}
